
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="hidden md:flex space-x-8">
        <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-medium">
          Home
        </a>
        <a href="/about" className="text-white hover:text-yellow-400 transition-colors duration-300 font-medium">
          About
        </a>
        <a href="/services" className="text-white hover:text-yellow-400 transition-colors duration-300 font-medium">
          Services
        </a>
        <a href="/gallery" className="text-white hover:text-yellow-400 transition-colors duration-300 font-medium">
          Gallery
        </a>
        <a href="/contact" className="text-white hover:text-yellow-400 transition-colors duration-300 font-medium">
          Contact
        </a>
      </nav>
    </header>
  );
};

export default Header;
